export function toggleAriaHiddenOnBodyChildren(dialogNode, toggle) {
    if (!dialogNode)
        return;
    Array.prototype.forEach.call(document.querySelectorAll('body > *'), node => {
        if (node === dialogNode) {
            return;
        }
        if (toggle === 'off') {
            node.removeAttribute('aria-hidden');
        }
        else {
            node.setAttribute('aria-hidden', 'true');
        }
    });
}
//# sourceMappingURL=toggleAriaHiddenOnBodyChildren.js.map